import { ApiService }                 from '../../app-lite/api/api.service';
import { SessionService }             from '../../app-lite/sessions/session.service';
import { VehicleRegistrationServiceAjs } from './vehicle-registration.service.ajs';

import VehicleRegistrationSettingsHtml from './vehicle-registration.settings.html';

export function VehicleRegistrationsStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'VehicleRegistrationSettingsCtrl',
    name       : 'app.vehicle-registration-settings',
    templateUrl: VehicleRegistrationSettingsHtml,
    url        : '/vehicle-registration-settings',
    resolve    : {
      requests: ( vehicleRegistrationApi : VehicleRegistrationServiceAjs ) : ng.IPromise<number> => vehicleRegistrationApi.getRequests(),
      session : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations')
    }
  });
}